import {PublicClientApplication} from "@azure/msal-browser";
import {MsalProvider} from "@azure/msal-react";
import {NextUIProvider} from "@nextui-org/react";
import React,{useState} from 'react';
import {msalConfig} from './authConfig';
import Content from './components/layout/Content';
import { ApiInterceptor } from "./components/HOC/ApiInterceptor";

const msalInstance = new PublicClientApplication(msalConfig);

const App: React.FC = () => {
  const [contactInfo, setContactInfo] = useState<string>('');

  const handleOtpRequested = (contactInfo: string) => {
    setContactInfo(contactInfo);
  };

  const handleLoginSuccess = (accessToken: string, refreshToken: string) => {
    console.log('Login success:', accessToken, refreshToken);
  };

  return (
    <MsalProvider instance={msalInstance}>
      <ApiInterceptor>
        <NextUIProvider >
          <Content
            contactInfo={contactInfo}
            onOtpRequested={handleOtpRequested}
            onLoginSuccess={handleLoginSuccess}
          />
        </NextUIProvider>
      </ApiInterceptor>
    </MsalProvider>
  );
};

export default App;

